import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";

/**
 * Custom hook to handle authentication checks and redirect unauthenticated users.
 */
export const useAuthRedirect = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      console.log("User not authenticated, redirecting to login.");
      navigate('/'); // Redirect to home/login page
    }
  }, [isLoading, isAuthenticated, navigate]);

  // Return loading and authentication status for potential use in the component
  return { isLoading, isAuthenticated };
};